@if (!loadType) {
  <div>
    {{ label | translate }}
  </div>
}
@if (loadType) {
  <div>
    <ng-content></ng-content>
  </div>
}
